import { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';

import { LabelM } from '@sorare/core/src/atoms/typography';
import { useGQLSearchContext } from '@sorare/core/src/contexts/graphql-search';
import { useIntlContext } from '@sorare/core/src/contexts/intl';

export const BackendTotalResults = () => {
  const { formatNumber } = useIntlContext();
  const ctx = useGQLSearchContext();

  const nbHits = ctx?.nbHits ?? 0;

  const roundingIncrement = useMemo(() => {
    if (!nbHits) return 1;
    if (nbHits > 10000) return 10000;
    if (nbHits > 1000) return 1000;
    if (nbHits > 100) return 100;
    return 1;
  }, [nbHits]);

  if (!ctx) return null;

  const total = Math.floor(nbHits / roundingIncrement) * roundingIncrement;

  return (
    <LabelM color="var(--c-nd-600)">
      <FormattedMessage
        defaultMessage="{formattedTotal}{plus} {total, plural, one {result} other {results}}"
        values={{
          total,
          formattedTotal: formatNumber(total, {
            roundingMode: 'trunc',
          }),
          plus: roundingIncrement !== 1 ? '+' : '',
        }}
      />
    </LabelM>
  );
};
